const initialState = {
	userId: null,
	userNm: null,
	userAuth: null,
	loginType: null,
	isAdmin: false,
	isReader: false,
	isWriter: false,
	isReviewer: false,
	isSuperVisor: false,
	isExternal: false,
	isReady : false,
}

export default function userReducer(state = initialState, action) {
	switch (action.type) {
		case 'LOGIN': {
			return {
				...state,
				...action
			}
		}
		case 'LOGOUT': {
			return {
				...state,
				userId: null,
				userNm: null,
				userAuth: null,
				loginType: null
			}
		}
		default:
			return state
	}
}